import { useTranslation } from 'react-i18next';
import {
  IconCheckouts,
  IconCoin,
  IconCompanies,
  IconFlexPools,
  IconInbox,
  IconInfoRedesigned,
  IconUser,
  IconUsers,
} from 'assets/img';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { getFinancePaymentsDefaultFilter } from './utils';
import { hqRoutes } from '../../Routes';

export const useSidebarItems = () => {
  const { t } = useTranslation('hq-screen-specific');
  const { allowDocuments } = useFeatureFlagContext();

  return [
    {
      key: 'operations',
      name: t('sidebar.operations'),
      children: [
        {
          ...hqRoutes.FlexWorkers,
          key: 'operations',
          label: t('sidebar.operations'),
          icon: <IconUser />,
        },
        ...(allowDocuments
          ? [
              {
                ...hqRoutes.DocumentsPage,
                key: 'documents-page',
                label: t('sidebar.document_check'),
                icon: <IconInbox />,
              },
            ]
          : []),
        {
          ...hqRoutes.Accreditations,
          key: 'accreditations',
          label: t('sidebar.accreditations'),
          icon: <IconCheckouts />,
        },
        {
          ...hqRoutes.BankAccount,
          key: 'bank-accounts',
          label: t('sidebar.bank_accounts'),
          icon: <IconCoin />,
        },
      ],
    },
    {
      key: 'sales',
      name: t('sidebar.sales'),
      children: [
        {
          ...hqRoutes.Companies,
          key: 'sales',
          label: t('sidebar.companies'),
          icon: <IconCompanies />,
        },
      ],
    },
    {
      key: 'finance',
      name: t('sidebar.finance'),
      children: [
        {
          ...hqRoutes.Finance,
          key: 'finance',
          label: t('sidebar.finance'),
          icon: <IconCheckouts />,
        },
        {
          ...hqRoutes.Payments,
          path: `${hqRoutes.Payments.path}${getFinancePaymentsDefaultFilter()}`,
          key: 'paymentsTable',
          label: t('sidebar.payments'),
          icon: <IconCheckouts />,
        },
        {
          ...hqRoutes.PaymentUsers,
          key: 'paymentUsersTable',
          label: t('sidebar.payment_users'),
          icon: <IconUsers />,
        },
      ],
    },
    {
      key: 'admin',
      name: t('sidebar.admin'),
      children: [
        {
          ...hqRoutes.FeatureFlags,
          key: 'featureFlags',
          label: t('sidebar.feature_flags'),
          icon: <IconFlexPools />,
        },
        {
          ...hqRoutes.UploadPayments,
          key: 'payments',
          label: t('sidebar.upload_payments'),
          icon: <IconCoin />,
        },
        {
          ...hqRoutes.PlatformSettings,
          key: 'platformSettings',
          label: t('sidebar.platform_settings'),
          icon: <IconInfoRedesigned />,
        },
      ],
    },
    {
      key: 'settings',
      name: t('sidebar.settings'),
      children: [
        { ...hqRoutes.HQUsers, key: 'users', label: t('sidebar.users'), icon: <IconUsers /> },
      ],
    },
  ] as const;
};
